







































import { Component, Vue, Prop } from 'vue-property-decorator';
import SubMenu from '@/shared/side-bar/mandala-side-bar-sub-menu.component.vue';
import ProjectAvatarComponent from '@/shared/avatars/project/project-avatar.component.vue';
import Project from '@/domain/project/project.entity';

@Component({
  components: {
    SubMenu,
    ProjectAvatarComponent,
  },
})
export default class MenuProject extends Vue {
  @Prop() projects?: Project[];

  @Prop() subItems?: any;
}
